module.exports = function () {
  return new Worker(__webpack_public_path__ + "1ceaba858ed5e72dbe01.worker.js");
};